/**
 * Promo Pop-up
 * Opens the promo 3 seconds after page load. Once a visitor closes it, the
 * browser remembers that block id and the promo never opens again for them.
 * In the theme editor the delay and the memory are ignored; selecting a block
 * opens its pop-up.
 */

if (!customElements.get('promo-popup')) {
  const PROMO_POPUP_DELAY = 3000;
  const PROMO_POPUP_STORAGE_PREFIX = 'promo-popup-dismissed:';

  class PromoPopup extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog) return;

      this.storageKey = PROMO_POPUP_STORAGE_PREFIX + this.dataset.promoId;

      this.querySelectorAll('[data-promo-close]').forEach((el) => {
        el.addEventListener('click', () => this.close());
      });

      // Let the link navigate; just record the dismissal and close first
      this.querySelector('[data-promo-cta]')?.addEventListener('click', () => this.close());

      // Covers the close button, backdrop, Esc and the CTA
      this.dialog.addEventListener('close', () => {
        document.body.classList.remove('dialog-open');
        this.remember();
      });

      if (window.Shopify?.designMode || this.isDismissed()) return;

      // Start loading the photo during the delay so the card opens complete
      this.querySelector('img[loading="lazy"]')?.setAttribute('loading', 'eager');
      this.timer = setTimeout(() => this.open(), PROMO_POPUP_DELAY);
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      if (this.dialog?.open) document.body.classList.remove('dialog-open');
    }

    open() {
      if (!this.dialog || this.dialog.open) return;
      this.dialog.showModal();
      document.body.classList.add('dialog-open');
    }

    close() {
      if (this.dialog?.open) this.dialog.close();
    }

    remember() {
      if (window.Shopify?.designMode) return;
      try {
        localStorage.setItem(this.storageKey, '1');
      } catch (error) {
        // Storage blocked (private mode etc.); the promo may show again next visit
      }
    }

    isDismissed() {
      try {
        return localStorage.getItem(this.storageKey) !== null;
      } catch (error) {
        return false;
      }
    }
  }

  customElements.define('promo-popup', PromoPopup);

  document.addEventListener('shopify:block:select', (event) => {
    if (!(event.target instanceof PromoPopup)) return;
    document.querySelectorAll('promo-popup').forEach((popup) => {
      if (popup !== event.target) popup.close();
    });
    event.target.open();
  });

  document.addEventListener('shopify:block:deselect', (event) => {
    if (event.target instanceof PromoPopup) event.target.close();
  });
}
